var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-cart"},[_c('base-counter',{staticClass:"add-cart__base-counter",attrs:{"value":_vm.value,"max":_vm.item.quantity,"name":_vm.name},on:{"update":_vm.onUpdate}}),_c('base-btn',{staticClass:"add-cart__btn",attrs:{"icon":{ name: 'basket-solid', width: '24', height: '24' },"disabled":_vm.isDisabled || _vm.isLoading,"aria-label":"Добавить в корзину","size":"sm"},on:{"click":() => {
        _vm.isLogged ? _vm.onAdd() : _vm.onAddLocal();
      }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }